<script lang="ts">
import { defineComponent } from "vue";
import {
  formatProbeValue,
  getProbeType,
  shouldHideProbeValueUnit,
} from "@/shared/utils/probes";
import { injectProbe } from "@/shared/utils/injection";

export default defineComponent({
  ...injectProbe,
  computed: {
    formattedValue() {
      return formatProbeValue(this.probe.type, this.probe.filteredValue);
    },
    unit() {
      return getProbeType(this.probe.type).unit;
    },
    date() {
      return new Date(Date.now() - this.probe.filteredTime * 1000);
    },
    day() {
      return this.date.toLocaleDateString();
    },
    time() {
      return this.date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    showUnit() {
      return !shouldHideProbeValueUnit(
        this.probe.type,
        this.probe.filteredValue
      );
    },
  },
});
</script>

<template>
  <div class="card p-3 flex flex-col items-center">
    <div class="text-white font-medium text-lg mb-1">
      {{ $t("Mesure") }} {{ $t("WithFilt") }}
    </div>
    <div class="flex">
      <div class="text-3xl mr-2">
        {{
          probe.filteredValue === -1000
            ? $t("NotAvail")
            : `${formattedValue}${showUnit ? unit : ""}`
        }}
      </div>
      <div class="text-xs align-left text-bluenew">
        {{ $t("MeasureDate", { date: day }) }}<br />
        {{ $t("MeasureTime", { time }) }}
      </div>
    </div>
  </div>
</template>
